'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formats", "value", "onChange"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import UITextToolbarSelect from '../editor/UITextToolbarSelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import withDisabledContext from '../hoc/withDisabledContext';
import TextToolbarSelectOption from './TextToolbarSelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.formatting.FormatSelect.${suffix}`;
class FormatSelect extends Component {
  render() {
    const _this$props = this.props,
      {
        formats,
        value,
        onChange
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UITextToolbarSelect, Object.assign({}, rest, {
      searchable: false,
      options: formats,
      onChange: onChange,
      placeholder: I18n.text(i18nKey('placeholder')),
      value: value,
      optionRenderer: option => /*#__PURE__*/_jsx(UITooltip, {
        disabled: !option.tooltip,
        placement: "right",
        title: option.tooltip,
        children: /*#__PURE__*/_jsx(TextToolbarSelectOption, {
          disabled: option.disabled,
          title: option.text,
          children: option.text
        })
      })
    }));
  }
}
FormatSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  formats: PropTypes.array.isRequired
};
export default withDisabledContext(FormatSelect);